import useSWR from 'swr'

import { options, propertyApi } from '../../apis/suitebookClient'
import { isTowerEleven } from '../../utils'

export const usePropertyDetailAvailabilitiesApi = (
  property?: string,
  fromDate?: string,
  toDate?: string,
  roomId?: number
) => {
  const {
    data: hotelData,
    isLoading: isHotelLoading,
    isValidating: isHotelValidating,
    error: hotelError,
    mutate: hotelMutate,
  } = useSWR(
    property
      ? `/hotels/${property}/availabilities${JSON.stringify({
          fromDate,
          toDate,
        })}`
      : null,
    property
      ? () =>
          propertyApi
            .getHotelAvailabilities(property, fromDate, toDate, options)
            .then((res) => res.data)
      : () => undefined,
    {
      revalidateOnFocus: false,
    }
  )

  const { data: roomData, isLoading: isRoomLoading } = useSWR(
    isTowerEleven(property)
      ? `/hotels/${property}/rooms/fieldview/availabilities${JSON.stringify({
          fromDate,
          toDate,
          roomId,
        })}`
      : null,
    isTowerEleven(property)
      ? () =>
          propertyApi
            .getRoomAvailabilities(
              property,
              'fieldview',
              fromDate,
              toDate,
              roomId,
              options
            )
            .then((res) => res.data)
      : () => undefined,
    {
      revalidateOnFocus: false,
    }
  )

  return {
    data: hotelData,
    roomData,
    isLoading: isHotelLoading || isRoomLoading,
    isValidating: isHotelValidating,
    error: hotelError,
    mutate: hotelMutate,
  }
}
